import React, { useState, useEffect } from "react";
import { Header } from "./Navbar.style";
import { CDBNavbar, CDBInput } from "cdbreact";
import axios from "axios";
import Form from "react-bootstrap/Form";
import "./Navbar.css";
// import  logout  from "../images/cauris.png";
import logout from "./images/logout-svgrepo-com.svg";
import { useHistory } from "react-router-dom";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import newChat from "./images/chat-new.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarChart } from "@fortawesome/free-regular-svg-icons/faBarChart";
import { faEdit } from "@fortawesome/free-regular-svg-icons/faEdit";
import { faRectangleList } from "@fortawesome/free-regular-svg-icons/faRectangleList";
import { faHome } from "@fortawesome/free-solid-svg-icons";

const Navbar = (props) => {
  const history = useHistory();
  const [isChecked, setIsChecked] = useState(true);
  const [showDataModal, setShowDataModal] = useState(false);
  const handleCloseDataModel = () => setShowDataModal(false);
  const [isDataReady, setIsDataReady] = useState(false);
  const [dataModalContent, setDataModalContent] = useState([]);

  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );
  console.log("NAV ABAR", profile);
  function onClickEditPrompts() {
    window.location.href =
      "/editPrompts?selected_index=" + props.selected_index;
  }

  function onShowSchema() {
    setShowDataModal(true);
    try {
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/getSchema",
          {
            database: props.partnerMetadata.partner_name + "_AGENT_V2",
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("SCHEMA", response.data.schema);
          setDataModalContent(response.data.schema);
          setShowDataModal(true);
          setIsDataReady(true);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error("Error processing message:", error);
    } finally {
    }
  }
  function logut() {
    googleLogout();
    localStorage.setItem("g_profile", null);
    history.push("/logout");
  }

  function onGoHome() {
    history.push("/");
  }

  function newChatClick() {
    props.setSelectedReportDashboard();
  }

  const handleChange = (event) => {
    setIsChecked(event.target.checked);
    props.setSendSlack(event.target.checked);
  };

  return (
    <Header>
      <Modal show={showDataModal} onHide={handleCloseDataModel} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Generated Data Schema</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {dataModalContent.map((data_schema) => (
              <div>
                <table className="schemaTable">
                  <thead>
                    <tr>
                      <th>{data_schema.tableName}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(data_schema.analysis).map((key_name) => (
                      <tr key={key_name}>
                        <td>{key_name}</td>
                        <td> </td>
                        <td nowrap>{data_schema.analysis[key_name]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p>&nbsp;</p>
              </div>
            ))}
          </div>

          {isDataReady ? (
            <div></div>
          ) : (
            <div className="monitorLoader">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDataModel}>
            Close
          </Button>{" "}
        </Modal.Footer>
      </Modal>
      <div className="navBarData">
        {props.partnerMetadata ? (
          <div className="navPartnerData">
            <img
              src={props.partnerMetadata.icon}
              alt=""
              className="profilePhoto"
            />
            {props.partnerMetadata.partner_name}
            <button
              onClick={onGoHome}
              className="logoutButton"
              title="Show the data schema"
            >
              <FontAwesomeIcon icon={faHome} /> {"   "}
            </button>
            <button
              onClick={newChatClick}
              className="logoutButton"
              title="New Conversation"
            >
              <img className="logoutImage" src={newChat} alt="" />
            </button>
            <button
              onClick={onClickEditPrompts}
              className="logoutButton"
              title="Edit Agent Prompts"
            >
              <FontAwesomeIcon icon={faEdit} /> {"   "}
            </button>
            <button
              onClick={onShowSchema}
              className="logoutButton"
              title="Show the data schema"
            >
              <FontAwesomeIcon icon={faRectangleList} /> {"   "}
            </button>

            <Form>
              <Form.Check // prettier-ignore
                type="switch"
                id="custom-switch"
                label="Send to Slack"
                checked={isChecked}
                onChange={handleChange}
              />
            </Form>
          </div>
        ) : (
          <div className="navPartnerData"></div>
        )}

        {profile && profile.picture ? (
          <div className="profileBar">
            <img src={profile.picture} alt="" className="profilePhoto" />
            {"      "}
            <button onClick={logut} className="logoutButton" title="Logout">
              <img className="logoutImage" src={logout} alt="" />
            </button>
            <br></br>
          </div>
        ) : (
          <div className="profileBar"></div>
        )}
      </div>
    </Header>
  );
};

export default Navbar;
